export default "/assets/images/technology-graph-05.65297559aede87bc.svg";